/* 
 * Based on object-to-form data https://github.com/therealparmesh/object-to-formdata
 * Modified to use numbered indicies for Lists so that each item has a unique key
 */

function isObject(value) {
  return value === Object(value);
}

function isArray(value) {
  return Array.isArray(value);
}

function isFile(value) {
  return value instanceof File;
}

function makeArrayKey(key, i, numberedArray) {
  const lastClose = key.lastIndexOf(']'),
    lastOpen = key.lastIndexOf('[');
  const index = key.substring(lastOpen + 1, lastClose);
  if (
    key.length > 3 &&
    lastClose === key.length - 1 &&
    !isNaN(parseInt(index, 10))
  ) {
    return key;
  } else {
    return key + '[' + i + ']';
  }
}

function objectToIndexedFormData(obj, fd, pre, numberedArray) {
  fd = fd || new FormData();

  Object.keys(obj).forEach(function(prop) {
    var key = pre ? pre + '[' + prop + ']' : prop;

    if (isObject(obj[prop]) && !isArray(obj[prop]) && !isFile(obj[prop])) {
      objectToIndexedFormData(obj[prop], fd, key, numberedArray);
    } else if (isArray(obj[prop])) {
      obj[prop].forEach(function(value, i) {
        var arrayKey = makeArrayKey(key, i, numberedArray);

        if (isObject(value) && !isFile(value)) {
          objectToIndexedFormData(value, fd, arrayKey, numberedArray);
        } else {
          fd.append(arrayKey, value);
        }
      });
    } else {
      fd.append(key, obj[prop]);
    }
  });

  return fd;
}

export default objectToIndexedFormData;



// WEBPACK FOOTER //
// ./src/services/ObjectToIndexedFormData.js